"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPortalParentElement = void 0;
var consts_1 = require("./consts");
var getPortalParentElement = function () {
    var rootElement = document.getElementById(consts_1.ROOT_ID);
    if (!rootElement) {
        throw new Error('No root element found!');
    }
    var modalElement = document.getElementById(consts_1.MODAL_ID);
    if (!modalElement) {
        modalElement = document.createElement('div');
        modalElement.id = consts_1.MODAL_ID;
        rootElement.after(modalElement);
    }
    return modalElement;
};
exports.getPortalParentElement = getPortalParentElement;
